import { Modal, RadioButton, RadioButtonGroup } from '@carbon/react';
import { UpdateEvent } from 'api/dtos/event';
import { defineMessages, useIntl } from 'react-intl';
import { useState } from 'react';
import sharedMessages from 'Components/utils/sharedMessages';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (mode?: UpdateEvent) => void;
    isRecurring?: boolean;
    isLoading?: boolean;
};

const JoinEventModal = ({ isOpen, onClose, onConfirm, isRecurring, isLoading }: Props) => {
    const intl = useIntl();
    const [mode, setMode] = useState<UpdateEvent>(UpdateEvent.Single);

    const handleClose = () => {
        setMode(UpdateEvent.Single);
        onClose();
    };

    const handleConfirm = () => {
        onConfirm(isRecurring ? mode : undefined);
        setMode(UpdateEvent.Single);
    };

    return (
        <Modal
            open={isOpen}
            onRequestClose={handleClose}
            onRequestSubmit={handleConfirm}
            modalHeading={intl.formatMessage(messages.heading)}
            primaryButtonText={intl.formatMessage(messages.confirm)}
            secondaryButtonText={intl.formatMessage(sharedMessages.cancel)}
            closeButtonLabel={intl.formatMessage(sharedMessages.cancel)}
            primaryButtonDisabled={isLoading}
        >
            <p>{intl.formatMessage(messages.description)}</p>
            {isRecurring && (
                <RadioButtonGroup
                    legendText={intl.formatMessage(messages.scopeLabel)}
                    name="join-event-scope"
                    valueSelected={String(mode)}
                    onChange={(value) => { setMode(Number(value) as UpdateEvent); }}
                >
                    <RadioButton
                        id="join-event-single"
                        value={String(UpdateEvent.Single)}
                        labelText={intl.formatMessage(messages.singleScope)}
                    />
                    <RadioButton
                        id="join-event-future"
                        value={String(UpdateEvent.Future)}
                        labelText={intl.formatMessage(messages.futureScope)}
                    />
                </RadioButtonGroup>
            )}
        </Modal>
    );
};

const messages = defineMessages({
    heading: {
        id: 'src.Screens.Dashboard.Events.JoinEventModal.heading',
        defaultMessage: 'Dołącz do wydarzenia',
    },
    description: {
        id: 'src.Screens.Dashboard.Events.JoinEventModal.description',
        defaultMessage: 'Czy na pewno chcesz dołączyć do tego wydarzenia?',
    },
    scopeLabel: {
        id: 'src.Screens.Dashboard.Events.JoinEventModal.scopeLabel',
        defaultMessage: 'Zakres dołączenia',
    },
    singleScope: {
        id: 'src.Screens.Dashboard.Events.JoinEventModal.singleScope',
        defaultMessage: 'Tylko to wydarzenie',
    },
    futureScope: {
        id: 'src.Screens.Dashboard.Events.JoinEventModal.futureScope',
        defaultMessage: 'To i przyszłe',
    },
    confirm: {
        id: 'src.Screens.Dashboard.Events.JoinEventModal.confirm',
        defaultMessage: 'Dołącz',
    },
});

export default JoinEventModal;
